import { render, staticRenderFns } from "./ButtonsSubmitForm.vue?vue&type=template&id=a2c958a6"
import script from "./ButtonsSubmitForm.vue?vue&type=script&lang=js"
export * from "./ButtonsSubmitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports